// Hooks
import { createFormContext, useForm } from 'hooks';

export const UserContext = createFormContext();

export const useUser = useForm;
export default useUser;
